export const datafeedCricketFilters = Object.freeze({
  appealId: "appealId",
  batterHand: "batterHand",
  batterId: "batterId",
  batterRuns: "batterRuns",
  battingConnection: "battingConnection",
  battingShotType: "battingShotType",
  boundary: "boundary",
  bowlerHand: "bowlerHand",
  bowlerId: "bowlerId",
  bowlingFrom: "bowlingFrom",
  bowlingLength: "bowlingLength",
  bowlingLine: "bowlingLine",
  bowlingType: "bowlingType",
  bye: "bye",
  fielderId: "fielderId",
  freeHit: "freeHit",
  legBye: "legBye",
  noBall: "noBall",
  outcomeId: "outcomeId",
  wideOfCrease: "wideOfCrease",
});

export const datafeedDefaultCricketFilters = Object.keys(datafeedCricketFilters).reduce((acc, key) => {
  acc[key] = [];
  return acc;
}, {});

export const datafeedSoccerFilters = [
  { key: "suggested_queries", label: "Suggested Queries" },
  { key: "players", label: "Players" },
  { key: "goals", label: "Goals" },
  { key: "set_pieces", label: "Set Pieces" },
  { key: "shots_passes", label: "Shorts&Passes" },
  { key: "dribble", label: "Dribbles" },
  { key: "defensive_actions", label: "Defensive Actions" },
  { key: "goalkeeper", label: "GoalKeepers" },
  { key: "cards", label: "Cards" },
];
export const archiveFilters = [
  { key: "sports", label: "Sports" },
  { key: "seasons", label: "Seasons" },
  { key: "teams", label: "Teams" },
  { key: "actions", label: "Actions" },
  { key: "parameters", label: "Parameters" },
  { key: "periods", label: "Periods" },
  { key: "tags", label: "Tags" },
];

export const defaultVolleystationFilters = [
  { key: "suggestedQueries", label: "Suggested Queries", filterKey: "suggestedQueries" },
  { key: "sets", label: "Sets", filterKey: "setIds" },
  { key: "players", label: "Players", filterKey: "playerIds" },
  { key: "startZone", label: "Start Zones", filterKey: "startZones" },
  { key: "winZone", label: "Win Zones", filterKey: "winZones" },
];

export const defaultVolleystationFiltersMap = defaultVolleystationFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const sportsradarHandballFilters = [
  { key: "event", label: "Event", filterKey: "event" },
  { key: "shot_type", label: "Shot Type", filterKey: "shot_type" },
  { key: "scoring_zone", label: "Scoring Zone", filterKey: "scoring_zone" },
  { key: "goal", label: "Goal", filterKey: "goal" },
  { key: "scorer", label: "Scorer", filterKey: "scorer" },
  { key: "assist", label: "Assist", filterKey: "assist" },
  { key: "competitor", label: "Competitor", filterKey: "competitor" },
];

export const sportsMediaTennisFilters = [
  { key: "point", label: "Point", filterKey: "point" },
  { key: "serve", label: "Serve", filterKey: "serve" },
  { key: "shotType", label: "Shot Type", filterKey: "shotType" },
  { key: "stroke", label: "Stroke", filterKey: "stroke" },
];

export const nascarFilters = [
  { key: "flags", label: "Flags", filterKey: "flags" },
  { key: "events", label: "Events", filterKey: "events" },
];

export const olympicIceHockeyFilters = [
  { key: "event", label: "Event", filterKey: "event" },
  { key: "player", label: "Player", filterKey: "player" },
  { key: "period", label: "Period", filterKey: "period" },
];

export const olympicCurlingFilters = [
  { key: "athletes", label: "Athletes", filterKey: "athletes" },
  { key: "events", label: "Events", filterKey: "events" },
  { key: "shotType", label: "Shot Type", filterKey: "shotType" },
  { key: "emotions", label: "Emotions", filterKey: "emotions" },
];

export const cbsAmericanFootballFilters = [
  { key: "quarter", label: "Quarter", filterKey: "quarter" },
  { key: "players", label: "Players", filterKey: "players" },
  { key: "down", label: "Down", filterKey: "down" },
  { key: "distance", label: "Distance", filterKey: "distance" },
  { key: "yardline", label: "Yardline", filterKey: "yardline" },
  { key: "play_type", label: "Play Type", filterKey: "play_type" },
  { key: "team_in_possession", label: "Team In Possession", filterKey: "team_in_possession" },
  { key: "scoring_plays", label: "Scoring Plays", filterKey: "scoring_plays" },
  { key: "under_review", label: "Under Review", filterKey: "under_review" },
];

export const cbsBasketballFilters = [
  { key: "period", label: "Period", filterKey: "period" },
  { key: "players", label: "Players", filterKey: "players" },
  { key: "play_type", label: "Play Type", filterKey: "play_type" },
  { key: "points", label: "Points", filterKey: "points" },
  { key: "shot_type", label: "Shot Type", filterKey: "shot_type" },
  { key: "shot_made", label: "Shot Made", filterKey: "shot_made" },
  { key: "shooting_team", label: "Shooting Team", filterKey: "shooting_team" },
];

export const nascarFiltersMap = nascarFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const sportsradarHandballFiltersMap = sportsradarHandballFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const sportsMediaTennisFiltersMap = sportsMediaTennisFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const olympicIceHockeyFiltersMap = olympicIceHockeyFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const olympicCurlingFiltersMap = olympicCurlingFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const cbsAmericanFootballFiltersMap = cbsAmericanFootballFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const cbsBasketballFiltersMap = cbsBasketballFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const datafeedBatsmanFilters = Object.freeze([
  datafeedCricketFilters.batterHand,
  datafeedCricketFilters.batterId,
  datafeedCricketFilters.batterRuns,
  datafeedCricketFilters.battingConnection,
  datafeedCricketFilters.battingShotType,
  datafeedCricketFilters.boundary,
]);

export const datafeedBowlerFilters = Object.freeze([
  datafeedCricketFilters.bowlerHand,
  datafeedCricketFilters.bowlerId,
  datafeedCricketFilters.bowlingFrom,
  datafeedCricketFilters.bowlingLength,
  datafeedCricketFilters.bowlingLine,
  datafeedCricketFilters.bowlingType,
]);

export const datafeedFielderFilters = Object.freeze([datafeedCricketFilters.fielderId]);

export const datafeedOutcomeFilters = Object.freeze([
  datafeedCricketFilters.outcomeId,
  datafeedCricketFilters.bye,
  datafeedCricketFilters.freeHit,
  datafeedCricketFilters.legBye,
  datafeedCricketFilters.noBall,
  datafeedCricketFilters.wideOfCrease,
]);

export const datafeedFilterLabels = {
  appealId: "Appeal",
  batterHand: "Batter Hand",
  batterId: "Batter",
  batterRuns: "Batter Runs",
  battingConnection: "Batting Connection",
  battingShotType: "Batting Shot Type",
  boundary: "Boundary",
  bowlerHand: "Bowler Hand",
  bowlerId: "Bowler",
  bowlingFrom: "Bowling From",
  bowlingLength: "Bowling Length",
  bowlingLine: "Bowling Line",
  bowlingType: "Bowling Type",
  bye: "Bye",
  fielderId: "Fielder",
  freeHit: "Free Hit",
  legBye: "Leg Bye",
  noBall: "No Ball",
  outcomeId: "Outcome",
  wideOfCrease: "Wide Of Crease",
};

export function extractFilteredState(filterArray, filterState) {
  return filterArray.reduce((acc, filterKey) => {
    const key = Object.keys(datafeedCricketFilters).find((key) => datafeedCricketFilters[key] === filterKey);
    if (key && filterState.hasOwnProperty(key)) {
      acc[key] = filterState[key];
    }
    return acc;
  }, {});
}
export const datafeedCricketFields = [
  { entityTitle: "Batsman", entityFilterFields: datafeedBatsmanFilters },
  { entityTitle: "Bowler", entityFilterFields: datafeedBowlerFilters },
  { entityTitle: "Fielder", entityFilterFields: datafeedFielderFilters },
  { entityTitle: "Outcomes", entityFilterFields: datafeedOutcomeFilters },
];

export const datafeedProviderOptions = [
  { label: "Genius", value: "genius" },
  { label: "Stats Perform", value: "statsPerform" },
  { label: "Sportradar", value: "sportRadar" },
  { label: "Volley Station", value: "volleyStation" },
  { label: "Sport Media", value: "sportMedia" },
  { label: "Olympics", value: "olympics" },
  { label: "CBS", value: "cbs" },
  { label: "KNKV", value: "knkv" },
  { label: "My Game Plan", value: "myGamePlan" },
  { label: "TV2", value: "tv2" },
  { label: "Ringier", value: "ringier" },
  { label: "SMT", value: "smt" },
  { label: "Feld", value: "feld" },
];

export const datafeedTypes = Object.freeze({
  GENIUS: "genius",
  STATS_PERFORM: "statsPerform",
  VOLLEY_STATION: "volleyStation",
  SPORT_RADAR: "sportRadar",
  SPORT_MEDIA: "sportMedia",
  NASCAR: "nascar",
  OLYMPICS: "olympics",
  CBS: "cbs",
  MY_GAME_PLAN: "myGamePlan",
  KNKV: "knkv",
  TV2: "tv2",
  RINGIER: "ringier",
  SMT: "smt",
  FELD: "feld",
});

export const allowedDatafeedCategoriesOnAddVideo = [
  "football",
  "basketball",
  "volleyball",
  "handball",
  "tennis",
  "ice_hockey",
  "curling",
  "American Football",
];

export const allowedDatafeedCateogriesForThumbnailTemplate = ["tennis"];

export const sportMediaTennisVideoFilters = [{ key: "court", label: "Court", filterKey: "court" }];

export const sportMediaTennisVideoFiltersMap = sportMediaTennisVideoFilters.reduce((map, filter) => {
  map[filter.label] = filter.filterKey;
  return map;
}, {});

export const datafeedClipCuttingCategories = {
  sportRadar: ["handball"],
  sportMedia: ["tennis"],
  volleyStation: ["volleyball"],
  statsPerform: ["football"],
  genius: ["basketball", "football", "volleyball"],
  cbs: ["American Football", "basketball"],
  tv2: ["handball", "ice_hockey"],
};

export const datafeedGraphicsProviders = ["sportMedia", "myGamePlan"];
